import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
// Validated categorical palette (dataviz skill: CVD-safe, contrast-checked against a white surface).
const palette = ['#16a34a', '#d97706', '#dc2626', '#1d4ed8', '#7c3aed'];

export default function PieCharts({ label = "50 Patients", height=50, data, legend=false }) {
    return (
        <Box>           
            <Typography variant='h6'>{label}</Typography>
            <PieChart
                colors={palette}
                slotProps={{ legend: { hidden: legend } }}
                series={[{ data }]} height={height} />
        </Box>

    );
}
